import React from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Button } from "@progress/kendo-react-buttons";
import SubmitButton from "components/common/SubmitButton";
import { IoAlertCircleOutline } from "react-icons/io5";

const CustomTitle = () => (
  <div
    style={{
      fontSize: "16px",
      lineHeight: "1.3em",
      color: "black",
      display: "flex",
      alignItems: "center",
    }}
  >
    <IoAlertCircleOutline className="me-2" size={20} color="#f59e0b" />
    Email Already Attached
  </div>
);

function sanitizeText(value) {
  if (!value) return "";
  let s = String(value);
  s = s.replace(
    /=\?([^?]+)\?([BbQq])\?([^?]*)\?=/g,
    (_, charset, enc, payload) => {
      try {
        if (enc.toLowerCase() === "b") {
          const decoded = atob(payload.replace(/\s+/g, ""));
          const bytes = Uint8Array.from(decoded, (c) => c.charCodeAt(0));
          return new TextDecoder(charset || "utf-8", { fatal: false }).decode(bytes);
        }
        return payload
          .replace(/_/g, " ")
          .replace(/=([0-9A-Fa-f]{2})/g, (_m, h) => String.fromCharCode(parseInt(h, 16)));
      } catch {
        return "";
      }
    },
  );
  s = s.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7F]/g, "");
  return s.trim();
}

function truncate(value, max) {
  if (!value) return "";
  return value.length > max ? value.slice(0, max - 1).trimEnd() + "…" : value;
}

export const EmailAlreadyAttachedDialog = ({
  open,
  existingMatterRef,
  existingMatterDetails,
  newMatterRef,
  emailSubject,
  onClose,
  onConfirm,
  loading,
}) => {
  if (!open) return null;

  const cleanSubject = truncate(sanitizeText(emailSubject), 80);
  const cleanMatterRef = sanitizeText(existingMatterRef) || "Unknown";
  const cleanMatterDetails = sanitizeText(existingMatterDetails);
  const cleanNewMatterRef = sanitizeText(newMatterRef) || "this matter";

  return (
    <Dialog title={<CustomTitle />} onClose={onClose} width={500}>
      <div className="p-4">
        {cleanSubject && (
          <div className="mb-3">
            <div className="text-muted small mb-1">Email</div>
            <div className="fw-medium text-truncate">{cleanSubject}</div>
          </div>
        )}

        <div className="mb-3">
          <div className="text-muted small mb-1">This email is attached to:</div>
          <div
            className="rounded p-3 d-flex flex-column"
            style={{ background: "#f6f8fb", border: "1px solid #eef0f4" }}
          >
            <span className="fw-semibold">{cleanMatterRef}</span>
            {cleanMatterDetails && (
              <span className="text-muted small">{cleanMatterDetails}</span>
            )}
          </div>
        </div>

        <div className="mb-1">
          Attach again to{" "}
          <span className="fw-semibold">{cleanNewMatterRef}</span>?
        </div>
      </div>

      <div className="d-flex justify-content-end w-100 gap-2 dialog-footer">
        <Button
          className="common-btn bgBtnSecondary"
          onClick={onClose}
          disabled={loading}
        >
          Cancel
        </Button>
        <SubmitButton
          className="common-btn me-3"
          onClick={onConfirm}
          isLoading={loading}
          disabled={loading}
        >
          Attach
        </SubmitButton>
      </div>
    </Dialog>
  );
};

export default EmailAlreadyAttachedDialog;
